// extracted by mini-css-extract-plugin
export default {"dangerModal":"delete-user-modal-styles_dangerModal__YoPV2"};